import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import CheckIcon from "@mui/icons-material/Check";
import PendingIcon from "@mui/icons-material/Pending";
import { useState, useEffect } from "react";
import api from "../config/axios";
import { useNavigate } from "react-router-dom";

const upcomingEventsData = [
  {
    listIcon: "/icons/giftIcon.svg",
    title: "Friend's Birthday",
    date: "Jun 25, 2028",
  },
  {
    listIcon: "/icons/moonIcon.svg",
    title: "Holiday",
    date: "Jun 28, 2028",
  },
  {
    listIcon: "/icons/groupIcon.svg",
    title: "Group Meetup",
    date: "Aug 19, 2028",
  },
  {
    listIcon: "/icons/educationIcon.svg",
    title: "Graduation",
    date: "Dec 22, 2028",
  },
];
const communityCards = [
  {
    id: "chess-game-online",
    imgSrc: "/images/chess.jpeg",
    name: "Chess Game Online",
    btnText: "Play Now",
    link: "/home/chess",
  },
  {
    id: "paasgen ad",
    imgSrc: "/images/web-browser-icon.png",
    name: "Paasgen Ad",
    btnText: "Paasgen Website - Check it out",
  },
];

const dummySuggestions = [
  {
    _id: "1",
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    profileImage: "/images/navbar-profile-pic.jpeg",
  },
  {
    _id: "2",
    firstName: "Jane",
    lastName: "Smith",
    email: "jane.smith@example.com",
    profileImage: "/images/navbar-profile-pic.jpeg",
  },
  {
    _id: "3",
    firstName: "Mike",
    lastName: "Johnson",
    email: "mike.j@example.com",
    profileImage: "/images/navbar-profile-pic.jpeg",
  },
];

function AppRightSidebar() {
  const [suggestions, setSuggestions] = useState([]);
  const [friendRequests, setFriendRequests] = useState([]);
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const currentUser = JSON.parse(localStorage.getItem("user"));

      if (!currentUser) {
        // If user is not logged in, show dummy data
        setSuggestions(dummySuggestions);
        setLoading(false);
        return;
      }

      // Get all users for suggestions
      console.log("Fetching users...");
      const usersResponse = await api.get("/auth/users");
      console.log("Users response:", usersResponse.data);

      // Get friend requests
      console.log("Fetching friend requests...");
      const requestsResponse = await api.get("/friends/requests");
      console.log("Friend requests:", requestsResponse.data);

      // Get friends
      console.log("Fetching friends...");
      const friendsResponse = await api.get("/friends");
      console.log("Friends:", friendsResponse.data);

      // Filter out current user and existing friends from suggestions
      const filteredSuggestions = usersResponse.data.filter((user) => {
        // Skip current user
        if (user._id === currentUser._id) {
          return false;
        }

        // Skip if already friends
        if (friendsResponse.data.some((friend) => friend._id === user._id)) {
          return false;
        }

        // Skip if there's a pending request
        if (
          requestsResponse.data.some(
            (request) =>
              (request.sender._id === user._id ||
                request.receiver._id === user._id) &&
              request.status === "pending"
          )
        ) {
          return false;
        }

        return true;
      });

      console.log("Filtered suggestions:", filteredSuggestions);
      setSuggestions(filteredSuggestions);
      setFriendRequests(requestsResponse.data);
      setFriends(friendsResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      setError("Error loading suggestions. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendRequest = async (userId) => {
    try {
      console.log("Sending friend request to user:", userId);
      const response = await api.post(`/friends/send-request/${userId}`);
      console.log("Friend request response:", response.data);

      // Show success message
      alert("Friend request sent successfully!");

      // Refresh data to update UI
      fetchData();
    } catch (error) {
      console.error("Error sending friend request:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
      alert(error.response?.data?.message || "Error sending friend request");
    }
  };

  const handlePlayNow = (link) => {
    if (link === "/home/chess") {
      navigate(link, { state: { fromSidebar: true } });
    } else {
      // For other games/apps, just navigate without special state
      navigate(link);
    }
  };

  if (loading) {
    return (
      <Stack
        sx={{
          width: "343px",
          bgcolor: "#ffffff",
          p: "22px",
          borderRadius: "22px",
          height: "max-content",
        }}
      >
        <Typography>Loading suggestions...</Typography>
      </Stack>
    );
  }

  return (
    <Stack
      sx={{
        width: "343px",
        bgcolor: "#ffffff",
        p: "22px",
        borderRadius: "22px",
        height: "max-content",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Friends Suggestions{" "}
        <Button
          sx={{
            "& .MuiButton-endIcon": {
              ml: "2px",
            },
            color: "#FEC31E",
            p: "0px",
            m: "0px",
            textTransform: "none",
          }}
          endIcon={
            <ArrowOutwardIcon
              sx={{ width: "16px", height: "16px", color: "#FEC31E" }}
            />
          }
        >
          See all
        </Button>
      </Typography>
      <Box sx={{ pt: "14px" }}>
        {suggestions.length === 0 ? (
          <Typography>No suggestions available</Typography>
        ) : (
          suggestions.map((user) => (
            <List key={user._id} sx={{ py: "0px" }}>
              <ListItem sx={{ p: "0px" }}>
                <ListItemAvatar>
                  <Avatar
                    src={user.profileImage || "/images/default-avatar.jpeg"}
                    alt={user.firstName}
                    sx={{ width: 48, height: 48, objectFit: "cover" }}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={`${user.firstName} ${user.lastName}`}
                  secondary={`@${user.email.split("@")[0]}`}
                  sx={{
                    "& .MuiTypography-root": { pl: "4px" },
                    "& .MuiTypography-body1": {
                      color: "#475569",
                      fontWeight: "bold",
                      pb: "2px",
                    },
                    "& .MuiTypography-body2": {
                      color: "#475569",
                      fontWeight: "500",
                    },
                  }}
                />
                <IconButton
                  edge="end"
                  onClick={() => {
                    const currentUser = JSON.parse(
                      localStorage.getItem("user")
                    );
                    if (!currentUser) {
                      alert("Please login to send friend requests");
                      return;
                    }
                    handleSendRequest(user._id);
                  }}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                    },
                  }}
                >
                  <AddIcon />
                </IconButton>
              </ListItem>
              <Divider
                sx={{
                  my: "10px",
                  height: "2px",
                  color: "#E2E8F0",
                  border: "none",
                }}
              />
            </List>
          ))
        )}
      </Box>

      <Stack id="community">
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: "10px",
          }}
        >
          Community{" "}
          <Button
            sx={{
              "& .MuiButton-endIcon": {
                ml: "2px",
              },
              color: "#FEC31E",
              p: "0px",
              m: "0px",
              textTransform: "none",
            }}
            endIcon={
              <ArrowOutwardIcon
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#FEC31E",
                }}
              />
            }
          >
            See all
          </Button>
        </Typography>
        {communityCards.map((communityCard, i) => (
          <Stack
            key={communityCard.id}
            id={communityCard.id}
            sx={{ bgcolor: "#f8f8f8", borderRadius: "15px", mb: "20px" }}
          >
            <Box
              component="img"
              src={communityCard.imgSrc}
              sx={{
                width: "270px",
                height: "250px",
                display: "block",
                borderRadius: "15px",
                bgcolor: "#B4E6FF",
              }}
            ></Box>
            <Box sx={{ p: "12px" }}>
              {" "}
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", pb: "2px" }}
              >
                {communityCard.name}
              </Typography>
              <Button
                onClick={() =>
                  communityCard.link && handlePlayNow(communityCard.link)
                }
                variant="outlined"
                sx={{
                  px: "18px",
                  border: "1px solid #E3E3E3",
                  bgcolor: "#ffffff",
                  color: "#000000",
                  textTransform: "none",
                  borderRadius: "50px",
                }}
              >
                {communityCard.btnText}
              </Button>
            </Box>
          </Stack>
        ))}
      </Stack>
      <Stack id="upcoming-events">
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Upcoming Events
          <IconButton sx={{ p: "0px" }}>
            <MoreVertIcon sx={{ color: "#CBD5E1" }} />
          </IconButton>
        </Typography>
        <Box sx={{ pt: "14px" }}>
          {upcomingEventsData.map((event) => (
            <List sx={{ py: "0px" }}>
              <ListItem sx={{ p: "0px" }}>
                <ListItemAvatar>
                  {/* <Avatar
                  src={event.listIcon}
                  alt="Profile Picture"
                
                  /> */}
                  <Avatar
                    sx={{
                      width: 48,
                      height: 48,
                      objectFit: "cover",
                      bgcolor: "#EBEBEB",
                    }}
                  >
                    <Box
                      component="img"
                      src={event.listIcon}
                      // sx={{ objectFit: "cover" }}
                    ></Box>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={event.title}
                  secondary={event.date}
                  sx={{
                    "& .MuiTypography-root": { pl: "4px" }, // Remove text padding
                    "& .MuiTypography-body1": {
                      color: "#475569",
                      fontWeight: "bold",
                      pb: "2px",
                    }, // Primary text
                    "& .MuiTypography-body2": {
                      color: "#475569",
                      fontWeight: "500",
                    }, // Secondary text
                  }}
                />
                <IconButton edge="end">
                  <Box component="img" src="/icons/bellIcon.svg"></Box>
                </IconButton>
              </ListItem>
              <Divider sx={{ my: "10px", height: "2px", color: "#E2E8F0" }} />
            </List>
          ))}
        </Box>
      </Stack>
    </Stack>
  );
}

export default AppRightSidebar;
